import React, { useEffect, useRef, useState } from "react";
import { getCustomerPicture } from "../../../api/schedulingApi";

export default function CustomerAvatar({ customer, botId, className = "h-10 w-10" }) {
  const [url, setUrl] = useState(customer?.profile_picture_url || "");
  const [failed, setFailed] = useState(false);
  const refreshed = useRef(false);
  const generation = useRef(0);
  useEffect(() => {
    generation.current += 1;
    setUrl(customer?.profile_picture_url || "");
    setFailed(false);
    refreshed.current = false;
    return () => { generation.current += 1; };
  }, [customer?.id, customer?.profile_picture_url, botId]);
  const imageFailed = async () => {
    setUrl("");
    if (refreshed.current || !botId || !customer?.profile_picture_file_id) {
      setFailed(true);
      return;
    }
    refreshed.current = true;
    const current = generation.current;
    try {
      const picture = await getCustomerPicture(botId, customer.id);
      if (current !== generation.current) return;
      setUrl(picture.profile_picture_url || "");
      setFailed(!picture.profile_picture_url);
    } catch {
      if (current === generation.current) setFailed(true);
    }
  };
  const name = customer?.name || "Customer";
  const gender = customer?.gender?.trim().toLowerCase();
  const avatarGender = gender === "male" || gender === "female" ? gender : "neutral";
  return <span className={`inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-cyan-50 text-sm font-semibold text-cyan-800 ${className}`}
    title={failed ? "Profile picture unavailable. Reload customer details to retry." : undefined}>
    {url ? <img src={url} alt={`${name} profile`} loading="lazy" referrerPolicy="no-referrer" className="h-full w-full object-cover"
      onLoad={() => { refreshed.current = false; }} onError={imageFailed} />
      : <svg viewBox="0 0 64 64" role="img" aria-label={`${name} default ${avatarGender} profile`}
        className="h-full w-full">
        <circle cx="32" cy="32" r="32" fill={avatarGender === "neutral" ? "#e2e8f0" : gender === "female" ? "#fce7f3" : "#e0f2fe"} />
        {avatarGender === "neutral" ? <>
          <circle cx="32" cy="23" r="12" fill="#64748b" />
          <path d="M10 64V56c0-12 10-18 22-18s22 6 22 18v8" fill="#64748b" />
        </> : <>
          {gender === "female" && <path d="M17 37V24a15 15 0 0 1 30 0v13l5 8H12z" fill="#475569" />}
          <path d="M10 64V56c0-12 10-18 22-18s22 6 22 18v8" fill={gender === "female" ? "#be185d" : "#0369a1"} />
          <path d="M26 34h12v10l-6 6-6-6z" fill="#f3c6a5" />
          <ellipse cx="32" cy="25" rx="11" ry="14" fill="#f3c6a5" />
          <path d={gender === "female" ? "M20 25V22a12 12 0 0 1 24 0v3c-6-1-10-5-12-9-2 5-6 8-12 9z"
            : "M20 25V20a12 12 0 0 1 24 0v5l-4-7c-5 3-10 4-16 3l-2 4z"} fill="#475569" />
        </>}
      </svg>}
  </span>;
}
